// frontend/src/components/chat/TypingIndicator.jsx
import React from 'react'
import { motion } from 'framer-motion'
import { Bot } from 'lucide-react'

const TypingIndicator = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className="flex justify-start"
    >
      <div className="max-w-xs lg:max-w-md">
        <div className="relative px-4 py-3 rounded-2xl bg-gray-100 text-gray-900">
          {/* Typing animation */}
          <div className="flex items-center space-x-2">
            <div className="flex space-x-1">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  className="w-2 h-2 bg-gray-400 rounded-full"
                  animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.5, 1, 0.5]
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    delay: i * 0.2
                  }}
                />
              ))}
            </div>
            <span className="text-sm text-gray-600">AI is thinking...</span>
          </div>
        </div>

        {/* Avatar */}
        <div className="flex items-center space-x-2 mt-1">
          <div className="w-6 h-6 bg-gray-100 text-gray-600 rounded-full flex items-center justify-center text-xs">
            <Bot className="h-4 w-4" />
          </div>
          <span className="text-xs text-gray-500">AI Assistant</span>
        </div>
      </div>
    </motion.div>
  )
}

export default TypingIndicator